import { Box, Checkbox } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DataGrid from '../../../../table/DataGrid';
import DialogConfirmCancel from '../../../../dialog/DialogConfirm';
import useUsers from '../../../../../hooks/users/useUsers';
import Avatar from '../../../../avatar/Avatar';
import FilterButtonUsersClass from './Filter/Button';

const DialogAddUsers = ({ onClose, open, userIds = [], onAdd, columnsTable, userType, type }) => {
  const list = useSelector((state) => state?.user?.list || []);
  const totalList = useSelector((state) => state?.user?.totalList || []);
  const formData = useSelector((state) => state?.class?.form || {});
  const years = useSelector((state) => state?.tenant?.years || []);

  const [checkIds, setCheckIds] = useState(userIds);

  const state = useSelector((state) => state?.filter?.usersClass || {});
  const skip = useSelector((state) => state?.datatable?.user?.skip || 0);
  const rowsPerPage = useSelector((state) => state?.datatable?.user?.rowsPerPage || 50);

  const { isLoading, isLoadingList, getUsersByRoleId } = useUsers();

  useEffect(() => {
    const filter = state?.filter;
    let roleId = 'user';
    if (userType === 'students') {
      roleId = 'Student';
      let yearlevels = formData?.yearLevel;
      if (Array.isArray(filter?.yearLevel)) {
        yearlevels = filter?.yearLevel?.map((item) => item._id || item) || formData?.yearLevel;
      }
      filter['yearLevelId'] = yearlevels;
      filter['yearLevel'] = years.filter((year) => yearlevels?.includes(year._id));
      filter['userIds'] = userIds;
    }
    if (userType === 'teachers') {
      roleId = 'Teacher';
      filter['userIds'] = userIds;
    }
    getUsersByRoleId(roleId, skip, rowsPerPage, filter);
  }, [rowsPerPage, skip, state, userIds, state?.filter]);

  const onConfirm = async (e) => {
    e.preventDefault();
    const lcs = list.filter((row) => checkIds?.includes(row._id));
    onAdd(lcs);
    onClose();
  };

  const onSelectedAll = (checked) => {
    if (checked) {
      setCheckIds(totalList.map((row) => row._id));
    } else {
      setCheckIds([]);
    }
  };

  const onSelected = (id, checked) => {
    if (checked) {
      setCheckIds([...checkIds, id]);
    } else {
      setCheckIds(checkIds.filter((item) => item !== id));
    }
  };

  return (
    <DialogConfirmCancel
      id={`add-users-${userType}`}
      open={open}
      disabledConfirm={isLoading}
      onCancel={onClose}
      onConfirm={onConfirm}
      title={`add ${userType}`}
      onCloseHeader={true}
      maxWidth='lg'
    >
      <div className='h-screen-modal-content-footer overflow-auto'>
        <Box className='px-4 py-2 h-10 border-b border-b-2 border-primary text-primary-foreground flex items-center justify-between'>
          <FilterButtonUsersClass type={type} />
        </Box>
        <Box className='absolute top-20 bottom-4 inset-x-4'>
          <DataGrid
            id='users'
            nameModule='user'
            rows={list
              .filter((row) => !userIds?.includes(row._id))
              .map((row, index) => {
                const data = row.data || {};
                return {
                  ...row,
                  index: index + 1 + rowsPerPage * skip,
                  avatar: (
                    <div className='flex items-center justify-center'>
                      <Avatar size='small' variant='circular' alt={row?.code} src={`photos/${row?.photo}`} />
                    </div>
                  ),
                  ...data,
                  yearLevelUser: row.yearLevel?.map((yearLevel) => yearLevel.name).join(', '),
                  checkIds: (
                    <Checkbox
                      id={`checkbox-id-user-${row._id}`}
                      checked={checkIds.includes(row._id)}
                      onChange={(e) => onSelected(row._id, e.target.checked)}
                      color='primary'
                    />
                  )
                };
              })}
            loading={isLoadingList}
            totalRows={totalList.length}
            skip={skip}
            rowsPerPage={rowsPerPage}
            columns={[
              { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false },
              {
                show: true,
                key: 'checkIds',
                align: 'center',
                width: 15,
                label: (
                  <Checkbox
                    id={`checkbox-id-user-header`}
                    checked={checkIds.length > 0 && checkIds.length === totalList.length}
                    indeterminate={checkIds.length > 0 && checkIds.length < totalList.length}
                    onChange={(e) => onSelectedAll(e.target.checked)}
                    color='primary'
                  />
                )
              },
              ...columnsTable
            ]}
            labelNoRows={`You don't have any ${userType} yet`}
          />
        </Box>
      </div>
    </DialogConfirmCancel>
  );
};

export default DialogAddUsers;
